export default __webpack_public_path__ + "static/media/rounded-arrow.2b3a7213.svg";